/* jshint esversion: 6, -W097 */
/* globals require */
(function(angular) {
    'use strict';
    const app = angular.module('enervee');

    app.directive('resetLinkModal', [function() {
        return {
            restrict: 'E',
            controller: [
                '$scope',
                '$state',
                'AccountSettingsService',
                'IndexService',
                'ForgotPasswordService',
                function(
                    $scope,
                    $state,
                    AccountSettingsService,
                    IndexService,
                    ForgotPasswordService
                ) {

                    /**
                     * Resend `Reset Password Link` email.
                     * Sends and email to an existing user that has not set a password.
                     * @param email
                     */
                    $scope.sendResetPasswordLink = (email, nextUrl) => {
                        if (email === null) {
                            // Password reset being called from the account page

                            AccountSettingsService.getAccountInfo().then((accountInfo) => {
                                $scope.accountInfo = accountInfo;

                                const email = $scope.accountInfo.email;

                                $scope.alerts = [{'type': 'info', 'message': 'password set'}];

                                ForgotPasswordService.resetPassword(email).then(() => {
                                    const _resetPasswordSent = ForgotPasswordService.resetPasswordSent();
                                    if (_resetPasswordSent.success === true) {
                                        $scope.forgotUserEmail = email;
                                        IndexService.closeModal('#modal-reset-password-link');
                                        $state.go('auth.forgot-password-sent-modal');
                                    }
                                });

                            });
                        } else {
                            ForgotPasswordService.resetPassword(email, nextUrl).then(() => {
                                const _resetPasswordSent = ForgotPasswordService.resetPasswordSent();
                                if (_resetPasswordSent.success === true) {
                                    $scope.forgotUserEmail = email;
                                    $state.go('auth.forgot-password-sent-modal');
                                    IndexService.closeModal('#modal-reset-password-link');
                                }
                            });
                        }
                    };

                }],
            template: require('@app/shared/modals/resetPasswordLink/resetPasswordLink.html'),
        };
    }]);
})(angular);
